import { ChevronRightIcon } from "@heroicons/react/solid";
import { Link } from "@inertiajs/inertia-react";

export default ({ heading, breadcrumb, meta, children }) => {
    return (
        <div className="px-4 sm:px-6 md:px-8 lg:flex lg:items-center lg:justify-between">
            <div className="min-w-0 flex-1">
                <nav className="flex" aria-label={"Breadcrumb"}>
                    <ol className="flex items-center space-x-4">
                        {breadcrumb.map((item, idx) => (
                            <li key={idx}>
                                {idx === 0 ? (
                                    <div className="flex">
                                        <Link
                                            href={item.route}
                                            className="text-sm font-medium text-gray-500 hover:text-gray-700"
                                        >
                                            {item.name}
                                        </Link>
                                    </div>
                                ) : (
                                    <div className="flex items-center">
                                        <ChevronRightIcon
                                            className="h-5 w-5 flex-shrink-0 text-gray-400"
                                            aria-hidden="true"
                                        />
                                        <Link
                                            href={item.route}
                                            className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                        >
                                            {item.name}
                                        </Link>
                                    </div>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>
                <h2 className="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl">
                    {heading}
                </h2>
                <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
                    {meta?.map((item, idx) => (
                        <div
                            className="mt-2 flex items-center text-sm text-gray-500"
                            key={idx}
                        >
                            <item.icon
                                className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
                                aria-hidden="true"
                            />
                            {item.name}
                        </div>
                    ))}
                </div>
            </div>
            <div className="mt-5 flex lg:mt-0 lg:ml-4">{children}</div>
        </div>
    );
};
